import * as React from "react";
import { FunctionComponent } from "react";
import styles from "./StepWrap.module.scss";

export const StepWrap: FunctionComponent = (props) => {
  return <div className={styles.wrap}>{props.children}</div>;
};
